import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FormWrapper = styled.div`
  width: 100%;
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  box-shadow: 0 2px 1px ${Color.Grey150};
`

export const NavigationButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${Spacing.S12} ${Spacing.S32} ${Spacing.S16};
`

/* mb="15px" px="30px" pt="10px */
